import React from "react"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import { SFX } from "../../../utils/sound"

import styles from "./index.module.less"
const ModalList: StyledComponent<{
    list: { label: string; key: string; disabled?: boolean }[]
    onChange: (key: string) => void
    cur: string
}> = ({ className, style, onChange, list, cur }) => {
    return (
        <div className={classNames(styles.modalList, className)} style={style}>
            <div className={styles.listLine}></div>
            <div className={styles.scrollContainer}>
                <div className={styles.contentContainer}>
                    {list.map((r) => (
                        <div
                            key={r.key}
                            className={classNames(
                                styles.resultItem,
                                r.disabled && styles.disabled,
                                cur === r.key && styles.active
                            )}
                            onClick={() => {
                                SFX.play("commonClick")
                                onChange(r.key)
                            }}
                        >
                            <div className={styles.line}></div>
                            <div className={styles.activeDeco}></div>
                            <div className={styles.point}>
                                <div className={styles.firework}></div>
                                <div className={styles.basic}></div>
                                <div className={styles.top}></div>
                            </div>
                            <span>
                                {r.disabled
                                    ? i18n(
                                          i18nData,
                                          "rogue_4.game.gallery.lock"
                                      )
                                    : r.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ModalList
